import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useRef } from "react";
import { useSelector } from "react-redux";
import imagineHomeService from "./imagineHomeService";
import { Dialog } from "primereact/dialog";
import { Galleria } from "primereact/galleria";
import NewUpload from "../../components/NewUpload";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { superAdmin } from "../../lib/constants";

const ImageGallery = () => {
    const [images, setImages] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [tempImage, setTempImage] = useState({});
    const [loading, setLoading] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});
    const [item, setItem] = useState(null);
    const [vendor, setVendor] = useState("All");
    const [editRow, setEditRow] = useState({});
    const [skip, setSkip] = useState(0);
    const [first, setFirst] = useState(0);
    const serviceId = localStorage.getItem("serviceId");
    const history = useHistory();
    const isInitialRender = useRef(true);
    const [userVendors, setUserVendors] = useState([]);
    const { usersVendors } = useSelector((state) => state.usersVendors);
    const [mediaDialogVisible, setMediaDialogVisible] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showUploadDialog, setUploadDialog] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [pairedImageData, setPairedImageData] = useState([]);
    const toast = useRef();
    const acceptedFormatImages = ".png,.jpg,.jpeg";
    const userpermissions = JSON.parse(localStorage.getItem("permissions"))
    const isAdmin = (userpermissions.includes(superAdmin))

    const responsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 5,
        },
        {
            breakpoint: "960px",
            numVisible: 4,
        },
        {
            breakpoint: "768px",
            numVisible: 3,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
        },
    ];
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (images.length > 0) {
            const pairs = [];
            for (let i = 0; i < images.length; i += 2) {
                pairs.push([images[i], images[i + 1] || null]);
            }
            setPairedImageData(pairs);
        } else {
            setPairedImageData([]);
        }
    }, [images]);

    const resetAll = () => {
        setImages([]);
        setSelectedImages([]);
        setEditRow({});
    };
    const showToast = (severity, summary, detail) => {
        toast?.current?.show({ severity: severity, summary: summary, detail: detail });
    };

    const fetchData = async () => {
        resetAll();
        setLoading(true);
        try {
            const res = await imagineHomeService.fetchGalleryImages(serviceId);
            if (res && res.status === "ok") {
                setImages([...res.data]);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
        } finally {
            setLoading(false);
        }
    };
    const deleteImages = async () => {
        setDeleting(true);
        try {
            const payload = {
                serviceId: serviceId,
                imgPath: selectedImages.map((item) => item.s3Path),
            };
            const res = await imagineHomeService.deleteGalleryImages(payload);
            if (!res || res.status !== "ok") {
                setDeleting(false);
                showToast("error", "Error", `Failed to delete the selected image${selectedImages.length > 1 ? "s" : ""}`);
            } else {
                setDeleting(false);
                showToast("success", "Success", `${selectedImages.length} image${selectedImages.length > 1 ? "s" : ""} deleted successfully!`);
                setShowConfirmationDialog(false);
                fetchData();
            }
        } catch (error) {
            console.error("Error deleting image:", error);
            setDeleting(false);
        }
    };

    const editImage = async (e) => {
        e.target.blur();
        setUpdating(true);
        try {
            const payload = {
                serviceId: serviceId,
                name: editRow.value,
                imgPath: editRow.key,
            };
            const res = await imagineHomeService.editGalleryImageMetaData(payload);
            if (!res || res.status !== "ok") {
                setUpdating(false);
                showToast("error", "Error", `Failed to edit the image name`);
            } else {
                showToast("success", "Success", `Image name updated successfully!`);
                setUpdating(false);
                setEditRow({});
                fetchData();
            }
        } catch (error) {
            console.error("Error editing image:", error);
            setUpdating(false);
        }
    };
    const uploadImage = async () => {
        setUploadingFile(true);
        try {
            const formData = new FormData();
            formData.append("serviceId", serviceId);
            formData.append("file", tempImage.file);
            formData.append("name", tempImage.name);
            const res = await imagineHomeService.uploadGalleryImages(formData);
            if (!res || res.status !== "ok") {
                setUploadingFile(false);
                showToast("error", "Error", `Failed to upload the image`);
            } else {
                showToast("success", "Success", `Image uploaded successfully!`);
                setUploadingFile(false);
                setUploadDialog(false);
                setTempImage({});
                fetchData();
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setUploadingFile(false);
        }
    };
    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);

        if (!files || files.length === 0) return;

        setTempImage({ ...tempImage, file: files[0] });
    };

    const showData = (row, field) => {
        const key = row.s3Path;

        if (editRow?.key === key && field === "name") {
            return (
                <div className="flex align-items-center gap-2 mr-2">
                    <InputText
                        className="addFeatureInput"
                        value={editRow.value}
                        onChange={(e) => {
                            setEditRow({
                                key,
                                value: e.target.value,
                            });
                        }}
                    // style={{
                    //     fontFamily: "Gerstner-ProgramRegular",
                    //     background: "#FFF",
                    //     border: "1px solid var(--Sage, #9AAB89)",

                    //     borderRadius: "8px",
                    // }}
                    />

                    <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-text"
                        style={{ color: "#BFAD5B" }}
                        onClick={(e) => {
                            e.target.blur();
                            setEditRow({});
                        }}
                    />

                    <Button icon={updating ? "pi pi-spin pi-spinner" : "pi pi-check"} disabled={updating} className="p-button-rounded p-button-text" style={{ color: "#9AAB89" }} onClick={(e) => editImage(e)} />
                </div>
            );
        }

        if (field === "downloadable_url") {
            return (
                <img
                    style={{ width: "80px", height: "80px" }}
                    src={row.downloadable_url}
                    alt="thumbnail"
                    className="w-16 h-16 border-round cursor-pointer"
                    onClick={() => {
                        const formattedImages = [{ itemImageSrc: row.downloadable_url, thumbnailImageSrc: row.downloadable_url }];
                        setSelectedImage({
                            formattedImages,
                            url: row.downloadable_url,
                            name: row.name,
                        });
                        setMediaDialogVisible(true);
                    }}
                />
            );
        }

        return (
            <div className="flex align-items-center ">
                <p className="m-0 p-0">{row[field]}</p>
                {field === "name" && <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" style={{ color: "#9AAB89" }} onClick={(e) => handleEditClick(e, row)} />}
            </div>
        );
    };

    const handleEditClick = (e, row) => {
        e.target.blur();
        setEditRow({
            key: row.s3Path,
            value: row.name,
        });
    };

    if (!isAdmin) return (<div className="col-12 " style={{ color: "#01579B" }}>
        <div className="card flex flex-column align-items-center justify-content-center dijon-ivory" style={{ height: "60vh" }}>
            <span className="fa-solid fa-circle-info" style={{ fontSize: "3rem" }}></span>
            <h3 className='font-larken'>You are not authorized to access this page</h3>
        </div>
    </div>)

    return (
        <div className="col-12 grid card shadow-3 p-3 border-round align-items-center justify-content-between" style={{ fontFamily: "Inter", backgroundColor: "#FBF9F3" }}>
            <Toast ref={toast} />
            <div className="col-12">
                <div className="w-full flex justify-content-between align-items-center">
                    <h2 className="font-larken m-0 charcoal-color item-Header" style={{ whiteSpace: "nowrap", fontFamily: "Inter" }}>Image Gallery</h2>
                </div>
            </div>

            <div className="col-12">
                <div className="col-12">
                    <div className="manage-users-filters">
                        <div className="filter-item filter-checkbox">
                            <Checkbox
                                inputId="selectAll"
                                disabled={images.length === 0}
                                checked={images.length > 0 && selectedImages.length === images.length}
                                onChange={(e) => {
                                    e.originalEvent.target.blur(); // blur works here
                                    if (e.checked) setSelectedImages(images);
                                    else setSelectedImages([]);
                                }}
                            />
                            <label htmlFor="selectAll" className={`font-Gerstner-ProgramRegular text-lg ${images.length === 0 ? "text-gray-400" : "charcoal-color"}`}>
                                Select All
                            </label>
                        </div>

                        <div className="filter-actions">
                            {selectedImages.length > 0 && (
                                <Button
                                    onClick={(e) => {
                                        e.target.blur();
                                        setEditRow({});
                                        setShowConfirmationDialog(true);
                                    }}
                                    label="DELETE"
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-info font-Gerstner-ProgramRegular text-base font-semibold px-4 charcoal-color"
                                    style={{ float: "right", letterSpacing: "1.44px", backgroundColor: "#BFAD5B" }}
                                />
                            )}

                            <Button
                                onClick={(e) => {
                                    e.target.blur();
                                    setEditRow({});
                                    setUploadDialog(true);
                                }}
                                style={{
                                    float: "right",
                                    background: "white",
                                    fontFamily:"Inter",
                                    height: "40px",
                                    boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                    border: "1px solid #ddd",
                                    color: "#3d3d3d",
                                    borderRadius: "20px",
                                    padding: "10px 20px",
                                    whiteSpace: "nowrap"

                                }}
                                label="UPLOAD"
                                icon="pi pi-plus"
                                className="p-button-rounded p-button-info font-Gerstner-ProgramRegular text-base font-semibold px-4 charcoal-color"
                               
                            />
                        </div>
                    </div>
                </div>

                <DataTable tableStyle={{ tableLayout: "fixed" }} loading={loading} value={pairedImageData} responsiveLayout="scroll" className="w-full card-table" rowClassName={() => 'card-row'}>
                    <Column
                        bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader"
                        header="Select"
                        body={(row) =>
                            row[0] && (
                                <Checkbox
                                    inputId={row[0].s3Path}
                                    name="selectImg"
                                    checked={selectedImages.some((img) => img.s3Path === row[0].s3Path)}
                                    onChange={(e) => {
                                        setEditRow({});
                                        if (e.target.checked) {
                                            setSelectedImages([...selectedImages, row[0]]);
                                        } else {
                                            setSelectedImages(selectedImages.filter((img) => img.s3Path !== row[0].s3Path));
                                        }
                                    }}
                                />
                            )
                        }
                        style={{ width: "3rem" }}
                    />
                    <Column bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" header="Image" body={(row) => row[0] && showData(row[0], "downloadable_url")} />
                    <Column bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="text-lg font-bold text-left" header={
                        <div style={{ textAlign: "left" }}>
                            <span>Name</span>

                        </div>
                    } body={(row) => row[0] && showData(row[0], "name")} />
                    <Column
                        bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader"
                        header="Select"
                        body={(row) =>
                            row[1] && (
                                <Checkbox
                                    inputId={"img.s3Path"}
                                    name="selectAll"
                                    checked={selectedImages.some((img) => img.s3Path === row[1].s3Path)}
                                    onChange={(e) => {
                                        setEditRow({});
                                        if (e.target.checked) {
                                            setSelectedImages([...selectedImages, row[1]]);
                                        } else {
                                            setSelectedImages(selectedImages.filter((img) => img.s3Path !== row[1].s3Path));
                                        }
                                    }}
                                />
                            )
                        }
                        style={{ width: "3rem" }}
                    />
                    <Column bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" header="Image" body={(row) => row[1] && showData(row[1], "downloadable_url")} />
                    <Column bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" header={
                        <div style={{ textAlign: "left" }}>
                            <span>Name</span>

                        </div>
                    } body={(row) => row[1] && showData(row[1], "name")} />
                </DataTable>
            </div>

            {/* <DataTable value={images} loading={loading} responsiveLayout="scroll" className="datatable-box w-full " selectionMode="checkbox" selection={loading ? null : selectedImages} onSelectionChange={(e) => setSelectedImages(e.value)} dataKey="s3Path">
                <Column selectionMode={loading ? null : "multiple"} headerClassName="sage-ivory text-center white-space-nowrap" headerStyle={{ width: "3rem" }} bodyClassName="text-center"></Column>
                <Column body={(row) => showData(row, "downloadable_url")} header="Images" bodyClassName="text-md p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
                <Column body={(row) => showData(row, "name")} header="Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="sage-ivory text-lg text-white white-space-nowrap font-Gerstner-ProgramRegular" />
            </DataTable> */}

            {mediaDialogVisible && (
                <Dialog
                    style={{
                        width: "90vw",
                        maxWidth: "45rem",
                        color: "#1D1B1C",
                    }}
                    breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                    draggable={false}
                    header={<h3 className="m-0 font-light font-larken">{selectedImage.name}</h3>}
                    visible={mediaDialogVisible}
                    modal
                    onHide={() => setMediaDialogVisible(false)}
                >
                    <Galleria
                        className="my-galleria"
                        value={selectedImage.formattedImages}
                        responsiveOptions={responsiveOptions}
                        numVisible={1}
                        showThumbnails={false}
                        showIndicators={selectedImage.formattedImages?.length > 1}
                        showItemNavigators={selectedImage.formattedImages?.length > 1}
                        showItemNavigatorsOnHover={false} // keep arrows always visible
                        circular
                        style={{ maxWidth: "100%", textAlign: "center" }}
                        item={(item) => <img src={item.itemImageSrc} alt={selectedImage.name} style={{ width: "100%", height: "400px", objectFit: "contain" }} />}
                    />
                </Dialog>
            )}

            {showConfirmationDialog && (
                <Dialog
                    draggable={false}
                    header={<h3 className="m-0 font-light font-larken">{`Delete Image${selectedImages.length > 1 ? "s" : ""}`}</h3>}
                    visible={showConfirmationDialog}
                    style={{
                        width: "90vw",
                        maxWidth: "35rem",
                        color: "#1D1B1C",
                        fontFamily: "Gerstner-ProgramRegular",
                    }}
                    breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                    onHide={() => {
                        setShowConfirmationDialog(false);
                    }}
                    footer={
                        <div className="grid w-full gap-3">
                            <div className="col-12 md:col-6">
                                <Button
                                    label="No"
                                    className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                                    onClick={(e) => {
                                        e.target.blur();
                                        setShowConfirmationDialog(false);
                                    }}
                                    style={{
                                        letterSpacing: "1.44px",
                                    }}
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <Button
                                    disabled={deleting}
                                    label={deleting ? "Deleting..." : "Yes"}
                                    className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                                    style={{
                                        letterSpacing: "1.44px",
                                        backgroundColor: "#9AAB89",
                                        borderColor: "#9AAB89",
                                    }}
                                    onClick={(e) => {
                                        e.target.blur();
                                        deleteImages();
                                    }}
                                />
                            </div>
                        </div>
                    }
                >
                    <div className="flex  mt-3 text-base md:text-lg  font-Gerstner-ProgramRegular">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "1.8rem", color: "#f0ad4e" }} />
                        {`Are you sure you want to delete the selected image${selectedImages.length > 1 ? "s" : ""}?`}
                    </div>
                </Dialog>
            )}
            {showUploadDialog && (
                <Dialog
                    draggable={false}
                    header={<h3 className="m-0 font-light font-larken">{`Upload Image`}</h3>}
                    visible={showUploadDialog}
                    style={{ color: "#1D1B1C", fontFamily: "Gerstner-ProgramRegular" }}
                    onHide={() => {
                        setTempImage({});
                        setUploadDialog(false);
                    }}
                    footer={
                        <div className="grid w-full gap-3">
                            <div className="col-12 md:col-6">
                                <Button
                                    label="Cancel"
                                    className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                                    onClick={(e) => {
                                        e.target.blur();
                                        setUploadDialog(false);
                                        setTempImage({});
                                    }}
                                    style={{ letterSpacing: "1.44px" }}
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <Button
                                    disabled={uploadingFile}
                                    label={uploadingFile ? "Uploading..." : "Upload"}
                                    className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                                    style={{
                                        letterSpacing: "1.44px",
                                        backgroundColor: "#9AAB89",
                                        borderColor: "#9AAB89",
                                    }}
                                    onClick={(e) => {
                                        e.target.blur();
                                        uploadImage();
                                    }}
                                />
                            </div>
                        </div>
                    }
                >
                    <div className="grid col-12 gap-3">
                        <div className="w-full">
                            <NewUpload multiple={false} accept={acceptedFormatImages} onchange={handleFileChange} fileName={tempImage.file?.name ?? ""} uploadTextClassName="font-larken charcoal-color mt-3 mb-3 block text-xl" minWidth="80%" />
                        </div>

                        <div className="col-12">
                            <label htmlFor="light" className={"col-12 m-0 featuresDialogLabel inline-flex align-items-center justify-content-between"}>
                                Name
                            </label>

                            <InputText className="w-full addFeatureInput" style={{ height: "3rem" }} onChange={(e) => setTempImage({ ...tempImage, name: e.target.value })} />
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default ImageGallery;
